export const columnData = {  
    loadedData: JSON.parse(
'[ {"orgName":"<None>","orgCity":"<None>","orgState":"<None>","month":1,"year":2020,"amount":0,"grantType":"<None>","description":"","programArea":"","fundingType":"","":"","strategy2":"","donor":""}]'),
    userInputs: {
        minMonth: 1, 
        maxMonth: 12, 
        minYear: 1900, 
        maxYear: new Date().getFullYear(),
        minVal: "", 
        maxVal: "" ,
        orgNames: [],
        orgCities: [],
        orgStates: [],
        grantTypes: [],
        fundingTypes: [],
        programAreas: [],
        strategies: [],
        donors: [],
        anyTerms: false, 
        searchQueries: []
    }
}